import { MaterialIcons } from '@expo/vector-icons';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

interface Props extends TouchableOpacityProps {
  size?: number;
  color?: string;
}

const DeleteButton = (props: Props) => {
  const { size = 24, color = '#B41C1C' } = props;
  return (
    <TouchableOpacity {...props}>
      <MaterialIcons name="delete" size={size} color={color} />
    </TouchableOpacity>
  );
};

export default DeleteButton;
